export default __webpack_public_path__ + "static/media/commercial8.cdb1f010.PNG";